import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { HereResult } from '@user/store/services/hereGeoCoder'
import { PlaceListItem } from './PlaceListItem'
import { TextFieldProps } from '@mui/material/TextField'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Paper from '@mui/material/Paper'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

interface Props {
  open: boolean
  onClose: () => void
  onSelectPlace: (place: HereResult) => void
  places?: HereResult[]
  margin?: TextFieldProps['margin']
}

export const PlaceList: React.FC<Props> = (props) => {
  const { open, onClose, places = [], onSelectPlace, margin = 'none' } = props
  const tidalOn = useTidalThemeActive()

  const top = tidalOn ? '60px' : margin === 'none' ? '40px' : '50px'

  const theme = useTheme()

  return open ? (
    <ClickAwayListener onClickAway={onClose}>
      <Paper
        elevation={2}
        style={{
          zIndex: 1000,
          position: 'absolute',
          top,
          width: '100%',
          padding: theme.spacing(0.2),
        }}
      >
        <List>
          {places.length > 0 ? (
            places.map((place) => (
              <PlaceListItem
                key={place.id}
                place={place}
                onSelectPlace={onSelectPlace}
              />
            ))
          ) : (
            <ListItem>No Matches</ListItem>
          )}
        </List>
      </Paper>
    </ClickAwayListener>
  ) : null
}
PlaceList.displayName = 'PlaceList'
